import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  Box
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { connect } from 'react-redux';
import { addEnlmFeedback } from '../../../containers/Dashboard/actions';
import { isEmpty, get } from '../../../utils/lodash';
import I18n from '../../../config/locales';
import { detect } from 'detect-browser';

const useStyles = makeStyles(theme => ({
  paper: {
    width: theme.spacing(80)
  },
  dialogTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  close: {
    opacity: 0.5,
    cursor: 'pointer'
  },
  dialogContent: {
    padding: theme.spacing(0, 3)
  },
  textContent: {
    fontSize: 15
  },
  dialogActions: {
    padding: theme.spacing(2, 3),
    justifyContent: 'flex-start'
  },
  content: {
    padding: theme.spacing(2),
    border: '1px solid #E1E1E1',
    borderRadius: theme.spacing(0.5)
  },
  buttonText: {
    color: 'white',
    fontSize: 15,
    textTransform: 'none',
    letterSpacing: 0.3
  },
  cancelButton: {
    opacity: 0.5,
    fontSize: 15,
    textTransform: 'none',
    letterSpacing: 0.3
  },
  textField: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
  fontSize28: {
    fontSize: theme.spacing(3.5)
  },
  errorContent: {
    fontStyle: 'italic',
    fontSize: 14,
    color: theme.palette.primary.main
  }
}));

const Popup = props => {
  const { open, handleSave, handleClose, classes, title, reason, handleReasonChange, textContent, errorMsg } = props;

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
      classes={{ paper: classes.paper }}
    >
      <DialogTitle disableTypography className={classes.dialogTitle}>
        <Typography className={classes.fontSize28}>{title}</Typography>
        <CloseIcon className={classes.close} onClick={handleClose} />
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <Box className={classes.content}>
          <Typography className={classes.textContent}>{textContent}</Typography>
          <TextField
            className={classes.textField}
            value={reason}
            label={`${I18n.t('dashboard.enterComments')} *`}
            onChange={handleReasonChange}
          />
          {errorMsg && <Typography className={classes.errorContent}>{errorMsg}</Typography>}
        </Box>
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <Button onClick={handleClose} className={classes.cancelButton}>
          {I18n.t('buttons.cancel')}
        </Button>
        <Button
          onClick={handleSave}
          color="primary"
          variant="contained"
          className={classes.buttonText}
          disabled={!isEmpty(errorMsg) || isEmpty(reason)}
        >
          {I18n.t('buttons.proceed')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const SwitchToClassicUIPopup = props => {
  const classes = useStyles();
  const { handleClose, handleSave, open, isMobileView } = props;
  const [ reason, setReason ] = useState('');
  const [ errorMsg, setErrorMsg ] = useState('');
  const handleReasonChange = event => {
    let reasonForChange = event.target.value;
    if (reasonForChange.length <= 2000) {
      setReason(reasonForChange);
      setErrorMsg('');
    } else {
      setErrorMsg(I18n.t('dashboard.maxAllowedComment', { maxCount: 2000 }));
    }
  };

  const handleSaveReason = () => {
    const result = detect();
    const browser = get(result, 'name', 'NA');
    const os = get(result, 'os', 'NA');
    const browserVersion = get(result, 'version', 'NA');
    const browserWidth = props.windowWidth;
    const browserHeight = props.windowHeight;
    const isMobile = navigator.userAgent.includes('Mobile');
    props.addEnlmFeedback({
      body: { reason, browser, os, browserVersion, browserWidth, browserHeight, isMobile },
      successCbk: handleSave
    });
  };

  const textContent = I18n.t('dashboard.switchingBackNote');

  return (
    <div>
      <Popup
        open={open}
        handleClose={() => handleClose(false)}
        handleSave={handleSaveReason}
        reason={reason}
        handleReasonChange={handleReasonChange}
        keyValue="reason-for-change"
        classes={classes}
        title={I18n.t('dashboard.switchBackTitle')}
        isMobileView={isMobileView}
        textContent={textContent}
        errorMsg={errorMsg}
      />
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  addEnlmFeedback: payload => dispatch(addEnlmFeedback(payload))
});

const mapStateToProps = state => ({});

export default connect(mapStateToProps, mapDispatchToProps)(SwitchToClassicUIPopup);
